var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import BEM from "../bem";
import html from "../htmlTemplateTag";
import "./styles.scss";
import videojs from "video.js";
var widgetBem = BEM("instagram-video-feed-widget");
var videoBem = BEM("instagram-video");
/**
 * The target "area" that a video in the feed should take up, in rem^2 units.
 *
 * If a video has an aspect ratio of `w:h`, it will maintain its aspect ratio and have dimensions
 * such that the total area that the video takes up on screen (`w` * `h`) is `TARGET_AREA` rem^2
 * units. This makes it so that even for portrait, landscape, and square videos, they all feel
 * roughly the same size to the user, and we don't give unnecessary importance to one video (by
 * making it bigger) just because its aspect ratio happens to be different.
 */
var TARGET_AREA = 225; // 15rem * 15rem for square videos; other ratios are scaled appropriately
/**
 * The maximum height a video can be, in rem units.
 *
 * If we rely *only* on `TARGET_AREA` to scale the video up or down, we'd have problems with extreme
 * rectangular videos. Consider a case where we get a video with a ridiculous aspect ratio of 1:9999
 * (which obviously wouldn't actually happen considering we control the videos that get posted to
 * Instagram, but just as an example). If we scaled the video's dimension to take up `TARGET_AREA`
 * units of area, because the video is so tall and skinny, we'd likely end up with a video thousands
 * of pixels tall, messing up the flow of the page. Having a `MAX_HEIGHT` ensures that videos never
 * exceed this height. They still keep their aspect ratio though, so it's possible that the video
 * will have to have its total area scaled down to be less than `TARGET_AREA` to maintain that
 * aspect ratio and maximum height limit.
 * @see {@link MAX_WIDTH}
 */
var MAX_HEIGHT = 25;
/**
 * The maximum width a video can be, in rem units.
 *
 * Same as `MAX_HEIGHT`, but for the width. We can usually allow a greater maximum width than height
 * because the videos are lined up in a scrollable horizontal row, so having a wider video will just
 * shift the other videos in the row over by a few rem units, but it won't mess up the flow of the
 * rest of the page (since the height of the row will still be, at most, `MAX_HEIGHT` rem units).
 * @see {@link MAX_HEIGHT}
 */
var MAX_WIDTH = 35;
/**
 * The maximum number of posts to display. This is just the upper limit; the API is allowed to
 * return fewer posts than this if there aren't enough.
 */
var LIMIT = 12;
/**
 * The API endpoint for retrieving the most recent videos.
 */
var ENDPOINT = "https://scs-app-backend-481f8.web.app/api/v1/instagram/videos?limit=".concat(LIMIT);
var createWidgets = function () {
    "use strict";
    var widgetContainers = widgetBem.select();
    // Import and load video.js CSS styles by injecting a <link> into the page.
    var styles = document.createElement("link");
    styles.rel = "stylesheet";
    styles.href = "https://unpkg.com/video.js@7/dist/video-js.min.css";
    document.head.appendChild(styles);
    var fetchInstagramFeed = function () {
        var e_1, _a;
        widgetBem.modify({ state: "loading" });
        try {
            for (var widgetContainers_1 = __values(widgetContainers), widgetContainers_1_1 = widgetContainers_1.next(); !widgetContainers_1_1.done; widgetContainers_1_1 = widgetContainers_1.next()) {
                var widget = widgetContainers_1_1.value;
                widget.innerHTML = html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<div class=\"", "\">\n        Loading...\n      </div>"], ["<div class=\"", "\">\n        Loading...\n      </div>"])), widgetBem("loading"));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (widgetContainers_1_1 && !widgetContainers_1_1.done && (_a = widgetContainers_1.return)) _a.call(widgetContainers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        fetch(ENDPOINT)
            .then(function (data) { return data.json(); })
            .then(function (videoData) { return __awaiter(void 0, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.allSettled(videoData.map(function (videoObject) {
                            return new Promise(function (resolve, reject) {
                                var container = document.createElement("div");
                                container.classList.add(videoBem.className);
                                container.innerHTML = html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                    <div\n                      data-vjs-player\n                      class=\"", "\"\n                    ></div>\n                  "], ["\n                    <div\n                      data-vjs-player\n                      class=\"", "\"\n                    ></div>\n                  "])), videoBem("video-js-wrapper"));
                                var video = document.createElement("video");
                                video.classList.add("video-js", "vjs-scs-theme");
                                video.addEventListener("loadedmetadata", function () {
                                    // "Short" videos are less than 8.5s long. They get played automatically (on
                                    // mute) since they don't use very much data and they're usually just short
                                    // looping animations.
                                    if (this.duration <= 8.5) {
                                        this.setAttribute("data-short-video", "true");
                                        this.loop = true;
                                    }
                                    else {
                                        // This is a longer video, so we should disable autoplay and start the video
                                        // unmuted, just as you'd expect for a video you have to click on to play.
                                        this.autoplay = false;
                                        this.muted = false;
                                    }
                                    this.setAttribute("data-video-width", (this.videoWidth || 1).toString());
                                    this.setAttribute("data-video-height", (this.videoHeight || 1).toString());
                                    resolve([container, video]);
                                });
                                video.addEventListener("error", reject);
                                // Start the video off as muted and with autoplay enabled. This will be changed
                                // (to ignore autoplay and be unmuted) if the video is longer than a few seconds.
                                // Browsers typically allow autoplay on videos only when they are muted, so this
                                // just lets the browser know that we intend to autoplay the video, and are muting
                                // it to prevent blocking.
                                video.muted = true;
                                video.autoplay = true;
                                // video.js seems to only work when the <video> has a <source>, so we can't set
                                // the video's `src` attribute directly.
                                video.innerHTML = html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                    <source src=\"", "\" type=\"video/mp4\" />\n                  "], ["\n                    <source src=\"", "\" type=\"video/mp4\" />\n                  "])), videoObject.media_url);
                                video.poster = videoObject.thumbnail_url;
                                container.firstElementChild.appendChild(video);
                            });
                        }))];
                    case 1:
                        results = _a.sent();
                        // Get rid of videos that errored out.
                        return [2 /*return*/, results.flatMap(function (result) {
                                return result.status === "fulfilled" ? [result.value[0]] : [];
                            })];
                }
            });
        }); })
            .then(function (videoElements) {
            var e_2, _a, e_3, _b;
            if (videoElements.length === 0) {
                // Add an empty modifier.
                widgetBem.modify({ empty: true, filled: false });
                try {
                    for (var widgetContainers_2 = __values(widgetContainers), widgetContainers_2_1 = widgetContainers_2.next(); !widgetContainers_2_1.done; widgetContainers_2_1 = widgetContainers_2.next()) {
                        var container = widgetContainers_2_1.value;
                        // Write a message to let the user know it is empty.
                        container.innerHTML = html(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n              <div class=\"", "\">\n                No videos found. Check back later for more!\n              </div>\n            "], ["\n              <div class=\"", "\">\n                No videos found. Check back later for more!\n              </div>\n            "])), widgetBem("no-videos"));
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (widgetContainers_2_1 && !widgetContainers_2_1.done && (_a = widgetContainers_2.return)) _a.call(widgetContainers_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return [];
            }
            var allVideoElements = videoElements.map(function (container) { return container.querySelector("video"); });
            var elementClones = Array.from({
                length: widgetContainers.length,
            });
            elementClones[0] = videoElements;
            for (var i = 1; i < widgetContainers.length; i++) {
                elementClones[i] = Array.from({
                    length: videoElements.length,
                });
                for (var j = 0; j < videoElements.length; j++) {
                    elementClones[i][j] = videoElements[j].cloneNode(true);
                    allVideoElements.push(elementClones[i][i].querySelector("video"));
                }
            }
            // Add a class indicating that the widget has content.
            widgetBem.modify({ empty: false, filled: true });
            for (var i = 0; i < widgetContainers.length; i++) {
                // Clear the widget container's children.
                widgetContainers[i].textContent = "";
                try {
                    // Insert each event one-by-one.
                    for (var _c = (e_3 = void 0, __values(elementClones[i])), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var element = _d.value;
                        widgetContainers[i].appendChild(element);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
            return allVideoElements;
        })
            .then(function (videoElements) {
            var e_4, _a;
            var _b, _c;
            try {
                for (var videoElements_1 = __values(videoElements), videoElements_1_1 = videoElements_1.next(); !videoElements_1_1.done; videoElements_1_1 = videoElements_1.next()) {
                    var video = videoElements_1_1.value;
                    var container = video.parentElement.parentElement;
                    var width = (_b = video.getAttribute("data-video-width")) !== null && _b !== void 0 ? _b : "";
                    var height = (_c = video.getAttribute("data-video-height")) !== null && _c !== void 0 ? _c : "";
                    if (isNaN(+width) || isNaN(+height)) {
                        continue;
                    }
                    var dimensionScaler = Math.sqrt(TARGET_AREA / +width / +height);
                    if (dimensionScaler * +width > MAX_WIDTH) {
                        dimensionScaler = MAX_WIDTH / +width;
                    }
                    else if (dimensionScaler * +height > MAX_HEIGHT) {
                        dimensionScaler = MAX_HEIGHT / +height;
                    }
                    container.style.width = "".concat(+width * dimensionScaler, "rem");
                    container.style.height = "".concat(+height * dimensionScaler, "rem");
                    video.parentElement.style.height = "100%";
                    video.parentElement.style.width = "100%";
                    videojs(video, {
                        fluid: true,
                        controls: true,
                        language: "en",
                        playbackRates: [0.5, 1, 1.5, 2],
                    });
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (videoElements_1_1 && !videoElements_1_1.done && (_a = videoElements_1.return)) _a.call(videoElements_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
            widgetBem.modify({ state: "loaded" });
        })
            .catch(function () {
            var div = document.createElement("div");
            div.classList.add(widgetBem("errored").className);
            div.innerHTML = html(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          <div>There was a problem getting the Instagram videos.</div>\n          <button\n            class=\"", "\"\n          >\n            Try again\n          </button>\n        "], ["\n          <div>There was a problem getting the Instagram videos.</div>\n          <button\n            class=\"", "\"\n          >\n            Try again\n          </button>\n        "])), BEM.button({
                bg: "primary",
                text: "lightest",
                hover: "shadow",
            }));
            widgetBem.modify({ state: "errored" });
            for (var i = 0; i < widgetContainers.length; i++) {
                // Clear the widget container's children.
                widgetContainers[i].textContent = "";
                var clone = div.cloneNode(true);
                var button = clone.querySelector("button");
                button.addEventListener("click", fetchInstagramFeed);
                widgetContainers[i].appendChild(clone);
            }
        });
    };
    fetchInstagramFeed();
};
export default createWidgets;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
